module.exports = __webpack_public_path__ + "static/img/PK3.c91cc13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK3.jpg
// module id = FZHz
// module chunks = 0